<template>
  <button :disabled="disabled || loading" @click="$emit('click')">
    <span v-if="!loading">{{ text }}</span>
    <loading-spinner v-if="loading" :color="'white'"></loading-spinner>
  </button>
</template>

<script>
import LoadingSpinner from './LoadingSpinner'

export default {
  name: 'LoadingSpinnerButton',
  components: {
    LoadingSpinner,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/buttons.scss';

button {
  @include base-button-medium;
}
</style>
